import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Collapse the navigation into an expandable area on small screens. The wrapper switches from `<nav>` to `<sp-expandable-area>` so a menu button can toggle the items.
   *
   * @type {Boolean|String}
   * @default false
   */
  collapsable: booleanAttribute(),
  /**
   * Render the collapsible presentation at every breakpoint, not just on small screens. Use when the nav lives inside a narrow surface like a sidebar.
   *
   * @type {Boolean|String}
   * @default false
   */
  alwaysCollapsible: booleanAttribute(),
  /**
   * Title rendered on the menu button when the navigation is in its collapsed presentation.
   *
   * @type {String}
   * @default undefined
   */
  collapsableMenuTitle: {
    type: String,
    default: undefined,
  },
  /**
   * Re-collapse the menu after a click inside the items — typical mobile behaviour where tapping a link should close the menu.
   *
   * @type {Boolean|String}
   * @default false
   */
  collapseOnContentClick: booleanAttribute(),
  /**
   * Enable the stuck-to-top slot, intended to render alongside the menu button when the navigation is pinned at the top of the viewport.
   *
   * @type {Boolean|String}
   * @default false
   */
  stuckToTop: booleanAttribute(),
});
